import React, { FC, useState } from "react";
import { Form, Modal, Button, Alert } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { UserModel } from "../../../models/UserModel";
import { UserType } from "../../../types/UserType";
import ClipLoader from "react-spinners/ClipLoader";
import { useAuth } from "../../../hooks/useAuth";
import { AuthContext } from "../../../providers/AuthContextProvider";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_CANCEL, LANG_COMMON_CLINIC, LANG_COMMON_NAME, LANG_COMMON_NEW, LANG_COMMON_PASSWORD, LANG_COMMON_PASSWORD_MSG, LANG_COMMON_PAYMENT, LANG_COMMON_PROFILE, LANG_COMMON_SAVE, LANG_COMMON_USER, LANG_COMMON_USERS, LANG_ERROR, LANG_LIMIT_ERROR, LANG_WARNING_FILL_ALL } from "../../../lang";
import BusinessSelect from "../../../components/form/BusinessSelect";
import { useAPI } from "../../../hooks/useAPI";

interface Props {
    show: boolean
    onHide: () => void
    onSave: () => void
}
const PaymentAddModal: FC<Props> = ({ show, onHide, onSave }) => {
    const intl = useIntl();
    const {api} = useAPI();
    const schema = yup.object().shape({
        business_id: yup.number().required().positive(),
        start_at: yup.date().required(),
        end_at: yup.date().required(),
    });
    const [formWasSubmitted, setFormWasSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const initialValues = {
        business_id: -1,
        start_at: "",
        end_at: "",
    };

    const onSubmit = async (values: any) => {
        setLoading(true);
        setFormWasSubmitted(false);
        api().post(`/api/business/${values.business_id}/register-payment`, values)
            .then((response) => {
                onSave();
            })
            .catch((error) => {
                setHasError(true);
                setErrorMsg(error.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Modal
            show={show}
            onHide={() => {
                onHide();
                setFormWasSubmitted(false);
            }}
            className="modal-default"
        >
            <Formik
                validationSchema={schema}
                onSubmit={onSubmit}
                initialValues={initialValues}
            >
                {({
                    setFieldValue,
                    handleSubmit,
                    handleChange,
                    values,
                    touched,
                    isValid,
                    errors }) => (
                    <Form noValidate onSubmit={(e) => {
                        setFormWasSubmitted(true);
                        handleSubmit(e);
                    }}>
                        <Modal.Header closeButton closeVariant="white">
                            <Modal.Title>
                                {intl.formatMessage(LANG_COMMON_NEW)} {" "} {intl.formatMessage(LANG_COMMON_PAYMENT)}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {(!isValid && formWasSubmitted) && (<Alert variant={'danger'}>{intl.formatMessage(LANG_WARNING_FILL_ALL)}</Alert>)}
                            {hasError && (<Alert variant={'danger'}>{errorMsg}</Alert>)}
                            <Form.Group className="mb-3" controlId="business_id">
                                <Form.Label>{intl.formatMessage(LANG_COMMON_CLINIC)}</Form.Label>
                                <BusinessSelect
                                    businessId={values.business_id}
                                    onChange={(business_id) => {
                                        setFieldValue('business_id', business_id);
                                    }}
                                />
                            </Form.Group>
                            <div className="row">
                                <div className="col-md-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Válido De:</Form.Label>
                                        <Form.Control
                                            type="date"
                                            onChange={(e) => setFieldValue('start_at', e.target.value)}
                                            value={values.start_at}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Válido Até:</Form.Label>
                                        <Form.Control
                                            type="date"
                                            onChange={(e) => setFieldValue('end_at', e.target.value)}
                                            value={values.end_at}
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-light" onClick={onHide} className="btn-custom btn-custom-light">
                                {intl.formatMessage(LANG_COMMON_CANCEL)}
                            </Button>
                            <Button variant="primary" type={"submit"} disabled={loading} className="btn-custom bg-custom-gradient">
                                {loading ? <><ClipLoader color={'#ffffff'} loading={loading} size={'12px'} /> </> : intl.formatMessage(LANG_COMMON_SAVE)}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}

export default PaymentAddModal;